import React, { Component } from 'react';
import cn from 'classnames/bind';
import styles from './StatelessSwitcher.scss';

const cx = cn.bind(styles);

export default class StatelessSwitcher extends Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  renderButton(icon, text, url, elementStyle, textStyle, tooltip, isChecked, style) {
    return (
      <div
        className={cx({ Button: true, [elementStyle]: true })}
        style={style}
        data-tip={tooltip}
        data-for="global"
      >
        {icon}<span className={cn(styles.Text, textStyle)}>{text}</span>
      </div>
    );
  }

  handleClick() {
    const { onClick, isChecked } = this.props;
    if (onClick) onClick(isChecked);
  }

  render() {
    const {
      className,
      elementStyle,
      textStyle,
      leftIcon,
      rightIcon,
      leftText,
      rightText,
      leftUrl,
      rightUrl,
      isChecked,
      leftTooltip,
      rightTooltip,
      enabledStyle,
      enabledStyleChecked,
      enabledStyleNotChecked
    } = this.props;

    return (
          <div
            className={cx(className, styles.Buttons)}
            onClick={this.handleClick}
          >
            {
              this.renderButton(leftIcon, leftText, leftUrl, elementStyle, textStyle, leftTooltip, isChecked, {
                color: !isChecked ? 'rgba(0, 0, 0, 0.5)' : '#085286',
                opacity: !isChecked ? '.5' : 1,
                transition: '.25s ease-in-out',
                transitionDelay: '.25s'
              })
            }
            {
              this.renderButton(rightIcon, rightText, rightUrl, elementStyle, textStyle, rightTooltip, !isChecked, {
                color: isChecked ? 'rgba(0, 0, 0, 0.5)' : '#085286',
                opacity: isChecked ? '.5' : 1,
                transition: '.25s ease-in-out',
                transitionDelay: '.25s'
              })
            }
            {
              <div className={cn(styles.EnabledElement, enabledStyle, (isChecked ? enabledStyleChecked : enabledStyleNotChecked))}
                style={{
                  left: `${isChecked ? 0 : 6.5}%`,
                  WebkitTransform: `translate3d(${isChecked ? 0 : 100}%, 0, 0)`,
                  transform: `translate3d(${isChecked ? 0 : 100}%, 0, 0)`,
                  width: `${isChecked ? 55 : 47}%`,
                  transition: '.5s'
                }}
              />
            }
          </div>
    );
  }
};


// <Motion style={{x: spring(isChecked ? 1 : 0.5)}}>
//   {({x}) =>
//       this.renderButton(leftIcon, leftText, leftUrl, elementStyle, textStyle, isChecked, {
//         color: x < 0.75 ? 'rgba(0, 0, 0, 0.5)' : '#085286',
//         opacity: x
//       })
//   }
// </Motion>
// <Motion style={{x: spring(isChecked ? 0.5 : 1)}}>
//   {({x}) =>
//       this.renderButton(rightIcon, rightText, rightUrl, elementStyle, textStyle, !isChecked, {
//         color: x < 0.75 ? 'rgba(0, 0, 0, 0.5)' : '#085286',
//         opacity: x
//       })
//   }
// </Motion>
// <Motion style={{x: spring(isChecked ? 0 : 100)}}>
//   {({x}) =>
//     <div className={cn(styles.EnabledElement)}
//       style={{
//         left: 0,
//         WebkitTransform: `translate3d(${x}%, 0, 0)`,
//         transform: `translate3d(${x}%, 0, 0)`,
//       }} />
//   }
// </Motion>



// WEBPACK FOOTER //
// ./src/components/common/StatelessSwitcher/StatelessSwitcher.js